import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Grid, makeStyles, Typography } from "@material-ui/core";

import { COLORS } from "../../../../../theme/colors";
import { TextButton, TextInput } from "../../../../../components/base";
import userIcon from "../../../../../assets/images/icons/user.svg";
import emailIcon from "../../../../../assets/images/icons/email.svg";
import phoneIcon from "../../../../../assets/images/icons/phone.svg";
import { ClusterBuildingModal } from "./modals/clusterBuildingsModal";
import { Checkbox } from "../../../../../components/base/Checkbox";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `${theme.spacing(2)}px 0`,
  },
  index: {
    color: COLORS.grey,
    fontWeight: "bold",
    fontSize: 72,
    fontStyle: "italic",
  },
  input: {
    padding: `${theme.spacing(1.5)}px ${theme.spacing(1)}px`,
  },
}));

export const ClusterComponent = ({
  index,
  onClusterDataChange,
  buildings,
  removeCluster,
  data = {},
  errors = {},
}) => {
  const classes = useStyles();

  const [openModal, setOpenModal] = useState(false);
  const { user } = useSelector((state) => state.auth);

  const isSamePmUser = useMemo(() => {
    return !data.pm_data || data.pm_data.id === user.id;
  }, [data, user]);

  return (
    <>
      <Grid className={classes.root} container>
        <Grid item xs={1}>
          <Typography className={classes.index}>{index + 1}.</Typography>
        </Grid>

        <Grid item xs={11}>
          <Grid container alignItems="center">
            <Grid item xs={2}>
              <Typography>Cluster Name:</Typography>
            </Grid>

            <Grid item xs={6}>
              <TextInput
                value={data.name}
                fullWidth
                error={!!errors.name}
                onChange={(v) => {
                  onClusterDataChange(index, "name", v);
                }}
              />
            </Grid>

            <Grid item xs={4}>
              <Grid container alignItems="center" style={{ marginLeft: 8 }}>
                <Checkbox
                  checked={isSamePmUser}
                  onChange={(e) =>
                    onClusterDataChange(index, "pm_data", e.target.checked ? null : {})
                  }
                />
                <Typography>Overall-PM manages the cluster</Typography>
              </Grid>
            </Grid>
          </Grid>

          {!isSamePmUser && (
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>PM in charge:</Typography>
              </Grid>
              <Grid item xs={6}>
                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <TextInput
                      fullWidth
                      error={!!errors.pm?.username}
                      value={data.pm_data.username}
                      inputRootStyle={classes.input}
                      placeHolder="Name"
                      startAdornment={<img src={userIcon} />}
                      onChange={(v) => {
                        onClusterDataChange(index, "pm_data", { ...data.pm_data, username: v });
                      }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextInput
                      fullWidth
                      error={!!errors.pm?.email}
                      value={data.pm_data.email}
                      inputRootStyle={classes.input}
                      placeHolder="Email"
                      startAdornment={<img src={emailIcon} />}
                      onChange={(v) => {
                        onClusterDataChange(index, "pm_data", { ...data.pm_data, email: v });
                      }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextInput
                      fullWidth
                      error={!!errors.pm?.phone}
                      value={data.pm_data.phone}
                      inputRootStyle={classes.input}
                      placeHolder="Mobile number"
                      startAdornment={<img src={phoneIcon} />}
                      onChange={(v) => {
                        onClusterDataChange(index, "pm_data", { ...data.pm_data, phone: v });
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}

          <Grid container style={{ marginTop: 20 }}>
            <Grid item xs={2}>
              <Typography>Cluster Buildings:</Typography>
            </Grid>
            <Grid item xs={6}>
              {data.buildings?.length > 0 ? (
                <Grid container>
                  <Typography style={{ fontWeight: "bold" }}>
                    {data.buildings.length} selected.
                  </Typography>
                  <TextButton
                    text="Edit"
                    normalFontWeight
                    style={{ marginLeft: 4 }}
                    onClick={() => setOpenModal(true)}
                  />
                </Grid>
              ) : (
                <TextButton text="Select..." normalFontWeight onClick={() => setOpenModal(true)} />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <ClusterBuildingModal
        cluster={data}
        open={openModal}
        onClose={() => setOpenModal(false)}
        buildings={buildings}
        initialselectedBuildings={data.buildings}
        onSave={(selectedBuildingIds) =>
          onClusterDataChange(
            index,
            "buildings",
            buildings.filter((b) => selectedBuildingIds.includes(b.id))
          )
        }
        removeCluster={removeCluster}
      />
    </>
  );
};
